import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppComponent } from './app.component';
import { AppReducer } from './app.reducer';
import { AppRoutingModule } from './app-routing.module';
import { ChannelService } from './channel/channel.service';
import { ChannelWatchComponent } from './channel/watch.component';
import { environment } from 'src/environments/environment';
import { EPGComponent } from './channel/epg/epg.component';
import { HomeComponent } from './home/home.component';
import { PlayerModule } from './player/player.module';
import { RemoteControlComponent } from './remote/remote.component';
import { RemoteControlService } from './remote/remote.service';
import { PromoComponent } from './promo/promo.component';

registerLocaleData(localePT);
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RemoteControlComponent,
    EPGComponent,
    ChannelWatchComponent,
    PromoComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    // OnlyTV Modules
    PlayerModule,

    StoreModule.forRoot({app: AppReducer}),

    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),

  ],
  providers: [
    ChannelService,
    RemoteControlService,
    {provide: LOCALE_ID, useValue: 'pt-br'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
